import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameJustitiaDisplay extends cDisplay {

  private curScreen: cInlineDisplay
  private curSelected: any;
  private items:any[]

  init(){
    super.init()
    console.log('INIT JUSTITIA 1');

    this.curSelected = null;

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'return_item':
          this.returnToPosition(this.curSelected);
          break;
      }

      // if (b.command === 'return_head'){
      //   this.curSelected.mBody.setStatic(false)
      //   this.scene.matter.world.add(this.curSelected.spring);
      //   this.curSelected = null
      // }
    })

  }

  buildScene(){    
    super.buildScene();
    setTimeout(()=>this.setupDragging(),10)


  }

  setupDragging(){
    var c:cContainer = this.getByName('face_container');
    var dropTarget:cSprite = this.getByName('droparea');
    var cS:cScene = this.scene as cScene;

    //(this.scene as cScene).updateHook( ()=>this.updateHook() );
    this.items = [];
    c.getAll().forEach((e:any,i:any)=>{
      let ref:cSprite = e as cSprite
      ref.setInteractive({useHandCursor:true});
      cS.input.setDraggable( ref )
    });

    cS.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
      gameObj.x = Math.round(x);
      gameObj.y = Math.round(y);
    });

    cS.input.on('dragend',(p:any, gameObj:any)=>{
      let ref:cSprite = gameObj as cSprite;

      var pos = new Phaser.Geom.Point( ref.x, ref.y )
      var rect = dropTarget.getBounds()

      if (Phaser.Geom.Rectangle.ContainsPoint(rect,pos)){
        console.log('INSIDE', ref.name);
        this.curSelected = ref;
        cS.triggerSceneEvent('drop',{name:ref.name});
      }else{
        this.returnToPosition(ref)
      }
    })    
  }

  returnToPosition(ref){
    var orgPos =  ref.modules.layout.getOfs( ref.modules.data.data.ofs )
    var cS:cScene = this.scene as cScene;
    cS.tweens.add({
      targets: ref,
      ease: 'Back.easeOut',
      duration: 400,
      x: orgPos.x,
      y: orgPos.y
    });

  }


}
